import { React, useState, useEffect } from "react";
import AdminDashboardLayout from "../../layout/AdminDashboardLayout";
import { DashboardWrapper } from "../dashboard/dashboard.styled";
import { InformationsWrapper } from "../customer/customersPage.styled";
import { SelectField, InputField, PasswordField } from "../../components/Form/FormComponents";
import { Formgroup, ButtonGroup, Button } from "../Products/Forms/ProductForm.styled";
import FormAccordion from "../../components/Form/FormAccordion";
import { toast } from "react-toastify";
import { Backdrop, CircularProgress } from "@mui/material";
import saveIcon from "../../assets/icons/Edit-Square.svg";
import { getCurrentUserInfo, logoutUser } from "../../utils/UserAuth";
import { updateUserDetails, updateUserPassword } from "./utils";
import { useLocation, useNavigate } from "react-router-dom";
import AdminPin from "./AdminPin";
import AdminBankInfo from "./AdminBankInfo";
import OtherAdminDetails from "./OtherAdminDetails";
import { useSelector } from "react-redux";

function Profile() {
	const { companyInsuranceInfo, loading: genLoading } = useSelector((state) => state.app);

	const [formData, setFormData] = useState({
		lastName: getCurrentUserInfo().lastName,
		firstName: getCurrentUserInfo().firstName,
		email: getCurrentUserInfo().email,
		phone: getCurrentUserInfo().phone,
		gender: getCurrentUserInfo().gender,
		homeAddress: getCurrentUserInfo().homeAddress,
		privileges: getCurrentUserInfo().privileges,
		oldPassword: "",
		password: "",
		confirmPassword: "",
	});
	const [isEditable, setIsEditable] = useState(false);
	const [loading, setLoading] = useState(false);
	const [passwordError, setPasswordError] = useState(null);

	const navigate = useNavigate();
	const { state } = useLocation();

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	useEffect(() => {
		passwordValidation();
	}, [formData]);

	const passwordValidation = () => {
		const validatePassword = (password) => {
			let check = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,}$/;
			return password.match(check) ? true : false;
		};

		if (formData.password && validatePassword(formData.password)) {
			setPasswordError(null);
		} else if (!formData.password) {
			setPasswordError(null);
		} else {
			setPasswordError(
				"Password must contain at least 8 characters, 1 uppercase, 1 lowercase, 1 number and 1 special character"
			);
		}
	};

	const updateProfile = async () => {
		setLoading(true);
		try {
			let data = await updateUserDetails(formData);
			if (data && !data.error) {
				setLoading(false);
				toast.success("Profile updated successfully");
				setIsEditable(false);
			} else {
				setLoading(false);
				toast.error(data.error);
			}
		} catch (error) {
			setLoading(false);
			toast.error("Error updating profile");
		}
	};

	const updatePassword = async () => {
		if (formData.password === formData.confirmPassword) {
			setLoading(true);
			try {
				let data = await updateUserPassword({
					email: formData.email,
					password: formData.oldPassword,
					newPassword: formData.password,
				});
				if (data && !data.error) {
					setLoading(false);
					toast.success("Password updated successfully");
					logoutUser(navigate);
				} else {
					setLoading(false);
					toast.error(
						data?.error.includes("Invalid" || "incorrect") ? "Current password is incorrect" : data.error
					);
				}
			} catch (error) {
				setLoading(false);
				toast.error("Error updating password");
			}
		} else toast.error("New password and confirm password do not match");
	};

	useEffect(() => {
		if (state?.context) {
			window.scrollTo({
				top: document.body.scrollHeight,
				behavior: "smooth",
			});
		} else {
			return;
		}
	}, []);

	const isAllowedToUseWallet = () => {
		if (
			getCurrentUserInfo()?.privileges === "firstLineApproval" &&
			getCurrentUserInfo()?.role?.toLowerCase() === "finance"
		) {
			return true;
		}
		if (getCurrentUserInfo()?.privileges?.toLowerCase() === "super administrator") {
			return true;
		}
		if (getCurrentUserInfo()?.role?.toLowerCase() === "logistics") {
			return true;
		} else {
			return false;
		}
	};

	return (
		<AdminDashboardLayout>
			<Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={genLoading}>
				<CircularProgress color='inherit' />
			</Backdrop>
			<DashboardWrapper>
				<InformationsWrapper className='mt-5'>
					<FormAccordion className='mt-4' title='Profile information' open={true}>
						<div className='grid grid-cols-3 gap-5 mt-5'>
							<Formgroup type='users'>
								<label>Last name</label>
								<InputField
									name='lastName'
									handleChange={handleInputChange}
									isEditable={isEditable}
									value={formData?.lastName}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>First name</label>
								<InputField
									name='firstName'
									handleChange={handleInputChange}
									isEditable={isEditable}
									value={formData?.firstName}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>Email address</label>
								<InputField
									name='email'
									handleChange={handleInputChange}
									// isEditable={isEditable}
									value={formData?.email}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>Phone number</label>
								<InputField
									name='phone'
									handleChange={handleInputChange}
									isEditable={isEditable}
									value={formData?.phone}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>Gender</label>
								<SelectField
									name='gender'
									handleChange={handleInputChange}
									isEditable={isEditable}
									value={formData?.gender}
									options={["male", "female"]}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>Home address</label>
								<InputField
									name='homeAddress'
									handleChange={handleInputChange}
									isEditable={isEditable}
									value={formData?.homeAddress}
								/>
							</Formgroup>

							<Formgroup type='users'>
								<label>Department</label>
								<SelectField name='role' value={getCurrentUserInfo().role} />
							</Formgroup>

							<Formgroup type='users'>
								<label>Privileges</label>
								<InputField name='privileges' value={formData?.privileges} />
							</Formgroup>
						</div>

						<ButtonGroup>
							{isEditable ? (
								<>
									<Button onClick={updateProfile} type='submit' color='#ffffff' backgroundcolor='#003A50'>
										<p>Update</p>
									</Button>

									<Button
										color='#006770'
										border='true'
										backgroundcolor='#ffffff'
										onClick={() => setIsEditable(false)}>
										<p>Cancel</p>
									</Button>
								</>
							) : (
								<Button
									color='#fff'
									border='true'
									backgroundcolor='#003A50'
									onClick={() => setIsEditable(true)}>
									<img src={saveIcon} />
									<p>Edit Details</p>
								</Button>
							)}
						</ButtonGroup>
					</FormAccordion>
					<br /> <br />
					{getCurrentUserInfo()?.role?.toLowerCase() !== "logistics" && (
						<OtherAdminDetails companyData={companyInsuranceInfo} />
					)}
					<br /> <br />
					<FormAccordion className='mt-8' title='Change Password' open={true}>
						<form
							onSubmit={(e) => {
								e.preventDefault();
								updatePassword();
							}}>
							<div className='grid grid-cols-3 gap-5 mt-5'>
								<Formgroup type='users'>
									<label>Current Password</label>
									<PasswordField
										name='oldPassword'
										value={formData?.oldPassword}
										handleChange={handleInputChange}
										required={true}
									/>
								</Formgroup>

								<Formgroup type='users'>
									<label>New Password</label>
									<PasswordField
										name='password'
										value={formData?.password}
										handleChange={handleInputChange}
										required={true}
									/>
									{passwordError && <p style={{ color: "red" }}>{passwordError}</p>}
								</Formgroup>

								<Formgroup type='users'>
									<label>Confirm New Password</label>
									<PasswordField
										name='confirmPassword'
										value={formData?.confirmPassword}
										handleChange={handleInputChange}
										required={true}
									/>
								</Formgroup>
							</div>

							<ButtonGroup>
								<Button type='submit' color='#ffffff' backgroundcolor='#003A50'>
									<p>Update Password</p>
								</Button>
							</ButtonGroup>
						</form>
					</FormAccordion>
					<br /> <br />
					{isAllowedToUseWallet() && <AdminBankInfo />}
					<br /> <br />
					{isAllowedToUseWallet() && <AdminPin />}
				</InformationsWrapper>

				{loading && (
					<Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
						<CircularProgress color='inherit' />
					</Backdrop>
				)}
			</DashboardWrapper>
		</AdminDashboardLayout>
	);
}

export default Profile;
